

const APPCONFIG = {
  settings: {
    layoutBoxed: false,
    user:{}                             // true, false    
  },
};
export default APPCONFIG;
